import { api } from "./client";
import type { ContactUpdate, Profile, Referee } from "./types";

export const profileApi = {
  read: () => api.get<Profile>("/api/profile"),
  updateContact: (input: ContactUpdate) => api.put<Profile>("/api/profile/contact", input),
  updateReferees: (referees: Referee[]) =>
    api.put<Profile>("/api/profile/referees", { referees }),
  updateBody: (body_md: string) => api.put<Profile>("/api/profile/body", { body_md }),
};
